import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-stone-300">
        <div className="font-display text-3xl">Un instant...</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/" replace state={{ from: location }} />;
  return children;
}
